import React, { useEffect, useState } from "react";
import { Flex } from "@chakra-ui/react";
import Sidebar, { getFirstAllowedPage } from "./Sidebar";
import MainWindow from "./MainWindow";
import { AppContext } from "AppProvider/AppContext";
import { appRequest } from "routes";
import ToastNotification from "components/common/ToastNotification/ToastNotification";
import ErrorBoundary from "components/common/ErrorBoundary/ErrorBoundary";

function Dashboard(): JSX.Element {
  const [activePage, setActivePage] = useState<string>("");
  const [openMobileSideDrawer, setOpenMobileSideDrawer] = useState(false);
  const [displaySidebar, setDisplaySidebar] = useState<boolean>(true);
  const [notify, toastNotify] = useState<any>(null);
  const [userRole, setUserRole] = useState<string[]>([""]);
  const [companyType, setCompanyType] = useState<string>("");
  const [accountDetails, setAccountDetails] = useState<any>(null);
  const [license, setLicence] = useState<string>("");
  const [bapIds, setBapIds] = useState<any>([]);

  async function getAccountDetails() {
    let response: any = await appRequest("user", "accountDetails", {});
    if (response && response.status !== "error") {
      setAccountDetails(response.user);
      console.log("account details response", response)
      // setUserRole(response.permission);
      // setCompanyType(response.company?.type);
      // setLicence(response.company?.licence);
    }
  }

  async function getBapIds() {
    let response: any = await appRequest("seller", "bapIds", { id: null });
    if (response && response.status !== "error") {
      setBapIds(response.data);
    }
  }

  useEffect(() => {

    toastNotify({
      title: "Welcome Back!",
    });
    getAccountDetails();
    // getBapIds();
  }, []);

  useEffect(() => {
    if (accountDetails && !activePage) {
      const firstPage = getFirstAllowedPage(accountDetails);
      if (firstPage) {
        setActivePage(firstPage);
      }
    }
  }, [accountDetails, activePage]);


  // useEffect(() => {
  //   toast({
  //     title: "Welcome Back!",
  //     status: "success",
  //     duration: 5000,
  //     isClosable: true,
  //     position: "top-right",
  //   });
  //   getAccountDetails();
  // }, [toast]);


  return (
    <AppContext.Provider
      value={{
        userRole,
        license,
        companyType,
        accountDetails,
        setAccountDetails,
        notify,
        toastNotify,
        bapIds,
        setBapIds
      }}
    >
      <ErrorBoundary>
        <Flex>
          {displaySidebar ? (
            <Sidebar
              activePage={activePage}
              setActivePage={setActivePage}
              openMobileSideDrawer={openMobileSideDrawer}
              setOpenMobileSideDrawer={setOpenMobileSideDrawer}
            />
          ) : null}
          <MainWindow
            activePage={activePage}
            setActivePage={setActivePage}
            displaySidebar={displaySidebar}
            setDisplaySidebar={setDisplaySidebar}
            setOpenMobileSideDrawer={setOpenMobileSideDrawer}
          />
          <ToastNotification />
        </Flex>
      </ErrorBoundary>
    </AppContext.Provider>
  );
}

export default React.memo(Dashboard);
